module.exports = __webpack_public_path__ + "static/media/img-talentx-desktop-wallpaper.5fb50a9c.png";